/* eslint-disable import/no-cycle */
/* eslint-disable react/display-name */
import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { StatusLead, StatusTypes } from 'const';
import routes from 'routing/routes';
import spinnerIcon from 'ui/assets/img/spinner-icon.png';
import theme from 'ui/theme';
import MainFont from 'ui/typography/mainFont';

// eslint-disable-next-line import/no-cycle
import { Button, Icon, ToggleSwitch, Tooltip } from '..';
import {
  AccordionIcon,
  ActionIconWrapper,
  AdditionalText,
  CellWrapper,
  CellWrapperStatusMenu,
  CheckboxWrapper,
  DownArrowStatusMenu,
  DownArrowStatusMenuContainer,
  DownloadIcon,
  IconContainer,
  IconWrapper,
  ItemWrapper,
  LeadStatusMenu,
  SpinnerIcon,
  StatusIconwrapper,
  StatusMenuContainer,
  Void,
  VoidIcon
} from './style';
import { useLocation } from 'react-router-dom';

export const TruncateCell = ({
  colIndex,
  accessor,
  position,
  rowData,
  rowIndex,
  onTextClick = null
}) => (
  <CellWrapper
    key={colIndex}
    position={position}
    onClick={event => {
      if (onTextClick) onTextClick(event);
    }}
    data-tip={rowData[accessor]}
    data-for={`${colIndex}${rowIndex}${rowData[accessor]}`}
    data-delay-hide="1000"
  >
    <ItemWrapper type={accessor} value={rowData[accessor]}>
      <MainFont type="1">
        {!rowData?.[accessor]
          ? '-'
          : rowData[accessor].length > 16
          ? `${rowData[accessor].substring(0, 16)}...`
          : rowData[accessor]}
      </MainFont>
    </ItemWrapper>
    {rowData?.[accessor] && rowData[accessor]?.length > 16 && (
      <Tooltip id={`${colIndex}${rowIndex}${rowData[accessor]}`} />
    )}
  </CellWrapper>
);

export const TextCell = React.memo(
  ({
    colIndex,
    accessor,
    position,
    rowData,
    hovered,
    onTextClick = null,
    translated
  }) => {
    const { t } = useTranslation();

    const icons = string => {
      let icon;
      switch (string) {
        case 'in progress':
          icon = 'progress';
          break;
        case 'download':
        case 'installation':
          icon = 'exclamation';
          break;
        case 'installed':
          icon = 'icon-success';
          break;
        case 'downloadfailed':
          icon = 'exclamation';
          break;

        default:
          icon = '';
          break;
      }
      return icon;
    };
    return (
      <CellWrapper key={colIndex} position={position}>
        <ItemWrapper type={accessor} value={rowData[accessor]}>
          {accessor === 'status' &&
            icons((rowData[accessor] || '').toLowerCase()) && (
              <StatusIconwrapper>
                <Icon
                  size="16"
                  type={`icon-${icons(
                    (rowData[accessor] || '').toLowerCase()
                  )}`}
                />
              </StatusIconwrapper>
            )}
          <MainFont type={accessor === 'status' ? 'bold' : '1'}>
            {rowData[accessor]
              ? translated
                ? t(rowData[accessor].toLowerCase())
                : rowData[accessor]
              : '-'}
          </MainFont>
        </ItemWrapper>
      </CellWrapper>
    );
  }
);

export const StatusCellWithMenu = React.memo(
  ({
    colIndex,
    cellData,
    accessor,
    position,
    rowData,
    hovered,
    onStatusClick,
    onTextClick = null,
    translated
  }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { t } = useTranslation();
    const isNew = rowData.status === StatusLead.NEW;

    console.log('row', rowData)
    if (rowData && isMenuOpen && !hovered) {
      setIsMenuOpen(false);
    }


    const menu = () => {
      return (
        <DownArrowStatusMenuContainer
          onClick={() => {
            setIsMenuOpen(!isMenuOpen);
          }}
        >
          <DownArrowStatusMenu
            type="icon-chevron-up"
            color={theme().colors.mainBlue}
            toRotate={isMenuOpen}
          />
          <StatusMenuContainer>
            {isMenuOpen && (
              <LeadStatusMenu onClick={() => onStatusClick(rowData)}>
                <MainFont type="descriptionText">
                  {t('no_more_interested')}
                </MainFont>
              </LeadStatusMenu>
            )}
          </StatusMenuContainer>
        </DownArrowStatusMenuContainer>
      );
    };
    return (
      <CellWrapperStatusMenu key={colIndex} position={position}>
        <ItemWrapper type={accessor} value={rowData[accessor]}>
          <MainFont type={accessor === 'status' ? 'bold' : '1'}>
            {cellData?.translated ? t(rowData[accessor]) : rowData[accessor]}
          </MainFont>
        </ItemWrapper>
        {hovered?.leadId === rowData?.leadId && isNew ? menu() : null}
      </CellWrapperStatusMenu>
    );
  }
);

export const SeveralTextCell = React.memo(
  ({ colIndex, accessor, position, rowData }) => {
    const data = rowData[accessor] || [];

    const arrayToString = data.slice(1, data.length).join('</br>');

    return (
      <CellWrapper key={colIndex} position={position}>
        <ItemWrapper type={accessor} value={rowData[accessor]}>
          <MainFont type="1">{data[0] || '-'}</MainFont>
          {data.length > 1 && (
            <AdditionalText
              data-tip={arrayToString}
              data-for={`${JSON.stringify(data)}`}
              data-html
            >
              <MainFont type="bold" configuration={{ fontSize: 12 }}>
                +{(data?.length || 1) - 1}
              </MainFont>
            </AdditionalText>
          )}
        </ItemWrapper>
        <Tooltip id={`${JSON.stringify(data)}`} />
      </CellWrapper>
    );
  }
);

export const LinkChargerDetail = React.memo(
  ({ colIndex, accessor, position, rowData, pushUrl }) => {
    const goToCharger = serialNumber => {
      pushUrl(`${routes.chargers.path}/${serialNumber}`);
    };

    return (
      <CellWrapper
        link
        key={colIndex}
        position={position}
        onClick={() => goToCharger(rowData[accessor])}
        linkCharger
      >
        <ItemWrapper type={accessor}>
          <MainFont type="1">{rowData[accessor]}</MainFont>
        </ItemWrapper>
      </CellWrapper>
    );
  }
);

export const LinkLeadDetail = React.memo(
  ({ colIndex, accessor, position, rowData, pushUrl, rowIndex, role }) => {
    const goToLead = leadId => {
      pushUrl(`lead/${leadId}`);
    };

    /* return (
      <CellWrapper
        link
        key={colIndex}
        position={position}
        onClick={() => goToLead(rowData[accessor])}
        linkLead
        data-tip={rowData[accessor]}
        data-for={`${colIndex}${rowIndex}${rowData[accessor]}`}
        data-offset="{'top': -8}"
      >
        <ItemWrapper type={accessor}>
          <MainFont type="4">
            {!rowData?.[accessor]
              ? '-'
              : rowData?.[accessor].length > 8
              ? `...${rowData[accessor].substring(8)}`
              : rowData[accessor]}
          </MainFont>
        </ItemWrapper>
        {role && rowData?.[accessor] && rowData[accessor]?.length > 8 && (
          <Tooltip id={`${colIndex}${rowIndex}${rowData[accessor]}`} />
        )}
      </CellWrapper>
    );*/
    return (
      <CellWrapper
        link
        key={colIndex}
        position={position}
        onClick={() => goToLead(rowData[accessor])}
        linkLead
        data-tip={rowData[accessor]}
        data-for={`${colIndex}${rowIndex}${rowData[accessor]}`}
        data-offset="{'top': -8}"
      >
        <ItemWrapper type={accessor}>
          <MainFont type="4">
            {!rowData?.[accessor] ? '-' : `${rowData[accessor].substring(11)}`}
          </MainFont>
        </ItemWrapper>
      </CellWrapper>
    );
  }
);

export const AccordionTextCell = React.memo(
  ({ colIndex, type, position, onTextClick = null, children, value }) => (
    <CellWrapper
      key={colIndex}
      position={position}
      onClick={event => {
        if (onTextClick) onTextClick(event);
      }}
    >
      <ItemWrapper type={type} value={value}>
        <MainFont type={type === 'status' ? 'bold' : '1'}>{children}</MainFont>
      </ItemWrapper>
    </CellWrapper>
  )
);

export const CheckBox = React.memo(
  ({
    position,
    colIndex,
    selection,
    checked,
    rowIndex,
    hovered,
    onClickCheck,
    onPeople,
    selectedStatus,
    rowData,
    accessor,
    isLeadsList
  }) => {
    const { t } = useTranslation();

    const statusCheck = () => {
      if (onPeople) {
        return selectedStatus && selectedStatus !== hovered?.status;
      }
      if (isLeadsList) {
        return hovered?.status !== StatusLead.NEW;
      }
    };

    const loadTooltipText = () => {
      if (isLeadsList) {
        return `${t('leads_tooltip_manage')}`;
      }
      if (onPeople) {
        return `${t('people_tooltip_manage')}`;
      }
      return null;
    };

    const onClick = () => {
      if (onPeople) {
        if (!selectedStatus || !statusCheck()) {
          onClickCheck();
        }
      } else if (isLeadsList) {
        if (!statusCheck()) {
          onClickCheck();
        }
      } else return;
    };

    return (
      <CellWrapper po1sition={position}>
        <CheckboxWrapper
          data-tip={loadTooltipText()}
          data-for={`${colIndex}${rowIndex}${rowData[accessor]}`}
          key={colIndex}
          onClick={() => onClick()}
        >
          {selection && checked?.includes(rowIndex) ? (
            <IconWrapper>
              <Icon
                type="icon-checkok"
                size="18"
                color={theme().colors.white}
              />
            </IconWrapper>
          ) : (
            <>
              <VoidIcon hovered={hovered?.index === rowIndex} />
              {statusCheck() ? (
                <Tooltip id={`${colIndex}${rowIndex}${rowData[accessor]}`} />
              ) : null}
            </>
          )}
        </CheckboxWrapper>
      </CellWrapper>
    );
  }
);

export const ToggleAndTextCell = React.memo(
  ({
    checked,
    rowData,
    position,
    colIndex,
    onToggleRow,
    rowIndex,
    accessor,
    contentType,
    hovered,
    onResendEmailAction,
    cellData
  }) => {
    const { t } = useTranslation();
    return hovered?.index === rowIndex && !checked.includes(rowIndex) ? (
      rowData.status !== StatusTypes.PENDING ? (
        <CellWrapper position={position}>
          <ToggleSwitch
            key={colIndex}
            checked={rowData.status === StatusTypes.ENABLED}
            onChange={() => onToggleRow(rowData)}
          />
        </CellWrapper>
      ) : (
        <CellWrapper position={position}>
          <Button
            variant="resendEmailButton"
            onClick={e => {
              onResendEmailAction(e, rowData);
            }}
          >
            <MainFont type="resendEmailLabel">{t('resend_email')}</MainFont>
          </Button>
        </CellWrapper>
      )
    ) : (
      <TextCell
        accessor={accessor}
        contentType={contentType}
        position={position}
        rowData={rowData}
        translated={cellData?.translated}
      />
    );
  }
);

export const ProgressIconCell = React.memo(({ position, rowData, accessor }) =>
  rowData.hasOwnProperty('action_progress') ? (
    <ActionIconWrapper position={position}>
      <Icon
        type={rowData[accessor] ? 'icon-icon-success' : 'icon-close1'}
        size="30"
        color={
          rowData[accessor]
            ? theme().colors.statusGreen
            : theme().colors.statusRed
        }
      />
    </ActionIconWrapper>
  ) : (
    <div />
  )
);

export const DeleteIconCell = React.memo(
  ({ hovered, rowIndex, position, rowData, onDeleteRow }) => {
    const { t } = useTranslation();
    return (
      hovered?.index === rowIndex && (
        <>
          <IconContainer
            position={position}
            data-tip={t('disable_account_before_delete')}
            show
          >
            <Icon
              type="icon-bin"
              size="16"
              onClick={e => onDeleteRow(e, rowData)}
              disabled={rowData.status === StatusTypes.ENABLED}
              color={theme().colors.mainBlue}
            />
            {rowData.status === StatusTypes.ENABLED && <Tooltip />}
          </IconContainer>
        </>
      )
    );
  }
);

export const DownloadIconCell = React.memo(
  ({ onDownloadFile, rowData, size }) =>
    rowData?.fileStatus !== 'SUCCESS' ? (
      <DownloadIcon
        clickable
        className="icon-download1"
        onClick={e => onDownloadFile(e, rowData)}
        size={size}
      />
    ) : (
      <></>
    )
);

export const AccordionIconCell = React.memo(
  ({ onToggleAccordion, rowIndex, hovered, hasAccordion }) => {
    const [rotation, setRotation] = useState(false);
    const handleClick = () => {
      onToggleAccordion(rowIndex);
      setRotation(!rotation);
    };

    return (
      <>
        {hasAccordion ? (
          <AccordionIcon
            className="icon-chevron-up"
            onClick={handleClick}
            rotation={rotation}
            hovered={hovered?.index === rowIndex}
          />
        ) : (
          <Void />
        )}
      </>
    );
  }
);

export const IconCell = React.memo(
  ({
    iconType,
    size,
    onIconClick,
    accessor,
    rowData,
    position,
    toolTipText,
    colIndex,
    rowIndex,
    showOnHover,
    clickable,
    hovered,
    pushUrl
  }) => {
    const location = useLocation();

    const goToLead = leadId => {
      pushUrl(`${routes.lead.path}/${leadId}`);
    };

    const type =
      accessor === 'fileStatus' && rowData[accessor] === 'SUCCESS'
        ? 'icon-icon-success'
        : rowData[accessor] === 'WARNING'
        ? 'icon-exclamation'
        : rowData[accessor] === 'FAILURE'
        ? 'icon-close1'
        : rowData[accessor] === 'INPROGRESS'
        ? 'icon-progress'
        : accessor === 'usedInCampain' && rowData[accessor]
        ? ''
        : iconType;

    const color =
      rowData[accessor] === 'SUCCESS' || rowData[accessor] === 'INPROGRESS'
        ? theme().colors.statusGreen
        : rowData[accessor] === 'WARNING'
        ? theme().colors.semantic.primary
        : rowData[accessor] === 'FAILURE'
        ? theme().colors.statusRed
        : theme().colors.mainBlue;

    const isHidden = () => {
      if (
        location?.pathname?.includes('lead') &&
        rowData?.status &&
        rowData?.status !== StatusLead.NEW
      ) {
        return true;
      }
      return false;
    };

    if (rowData) {
      return (
        <IconContainer
          position={position}
          clickable={clickable}
          data-tip={rowData.fileStatus !== 'SUCCESS' ? toolTipText : null}
          data-for={`${colIndex}${rowIndex}${rowData[accessor]}`}
          show={
            location?.pathname?.includes('lead') && rowData?.status
              ? showOnHover && hovered?.leadId === rowData?.leadId
              : true
          }
          onClick={() =>
            location.pathname.includes('lead') && type === 'icon-pencil'
              ? goToLead(rowData.leadId)
              : null
          }
        >
          {rowData[accessor] === 'INPROGRESS' ? (
            <SpinnerIcon icon={spinnerIcon} />
          ) : (
            !isHidden() && (
              <Icon
                type={type}
                size={size}
                onClick={() => clickable && onIconClick(accessor, rowData)}
                color={color}
              />
            )
          )}

          {rowData.fileStatus !== 'SUCCESS' ? (
            <Tooltip id={`${colIndex}${rowIndex}${rowData[accessor]}`} />
          ) : null}
        </IconContainer>
      );
    } else return <></>;
  }
);

export const IconCellChargerCable = ({ size, accessor, rowData, position }) =>
  rowData[accessor] === 'Finishing' || rowData[accessor] === 'Preparing' ? (
    <IconContainer position={position}>
      <Icon type="icon-cable" size={size} color={theme().colors.mainBlue} />
    </IconContainer>
  ) : (
    <IconContainer position={position}>
      <div style={{ width: '48px' }} />
    </IconContainer>
  );

export const IconCellChargerAction = ({
  size,
  onIconClick,
  accessor,
  rowData,
  position
}) => {
  const type = ['available', 'preparing'].includes(
    rowData[accessor].toLowerCase()
  )
    ? 'icon-rounded-lightning'
    : 'icon-stop-charging';

  return (
    ['available', 'preparing', 'charging'].includes(
      rowData[accessor].toLowerCase()
    ) && (
      <IconContainer position={position}>
        <Icon
          type={type}
          size={size}
          color={theme().colors.mainBlue}
          onClick={() => onIconClick(rowData)}
        />
      </IconContainer>
    )
  );
};

const CellProps = {
  colIndex: PropTypes.number,
  rowIndex: PropTypes.number,
  cellData: PropTypes.object,
  rowData: PropTypes.object,
  checked: PropTypes.array,
  selection: PropTypes.bool,
  selected: PropTypes.array,
  onToggleRow: PropTypes.func,
  onDeleteRow: PropTypes.func,
  onDownloadFile: PropTypes.func,
  downloadable: PropTypes.bool,
  hovered: PropTypes.object,
  onTextClick: PropTypes.func,
  tooltipText: PropTypes.string,
  selectedStatus: PropTypes.string
};

const CellDataProps = {
  colIndex: PropTypes.number,
  accessor: PropTypes.string,
  position: PropTypes.string,
  rowData: PropTypes.object,
  showTooltip: PropTypes.bool
};

const IconProps = {
  type: PropTypes.string,
  size: PropTypes.string,
  onIconClick: PropTypes.func,
  name: PropTypes.string
};

CheckBox.propTypes = { ...CellProps, ...CellDataProps };
ToggleAndTextCell.propTypes = { ...CellProps, ...CellDataProps, ...IconProps };
ProgressIconCell.propTypes = { ...CellProps, ...CellDataProps };
DeleteIconCell.propTypes = { ...CellProps, ...CellDataProps };
DownloadIconCell.propTypes = { ...CellProps, ...CellDataProps };
AccordionIconCell.propTypes = { ...CellProps, ...CellDataProps };
IconCell.propTypes = { ...IconProps };
TruncateCell.propTypes = { ...CellProps };
LinkChargerDetail.propTypes = { ...CellProps };
LinkLeadDetail.propTypes = { ...CellProps };
IconCellChargerCable.propTypes = { ...CellProps };
TextCell.propTypes = { ...CellDataProps };
SeveralTextCell.propTypes = { ...CellDataProps };
